import { type MutableRefObject, type ReactEventHandler, memo } from "react";
import "Components/Global/VideoPlayer/VideoPlayer.less";
import AspectMaintainer from "Components/Global/AspectMaintainer";

type VideoPlayerProps = {
	onPlaying?: ReactEventHandler<HTMLVideoElement>;
	onTimeUpdate?: ReactEventHandler<HTMLVideoElement>;
	onWaiting?: ReactEventHandler<HTMLVideoElement>;
	canvasRef?: MutableRefObject<HTMLCanvasElement | null>;
};

function VideoPlayer(props: VideoPlayerProps) {
	const { canvasRef } = props;

	return (
		<AspectMaintainer>
			<canvas
				ref={ canvasRef }
				className="video-canvas"
			/>
		</AspectMaintainer>
	);
}

export default memo(VideoPlayer);
